<!-- Renderiza V3 si es flujo KrdYa, de lo contrario V2 -->
<app-sales-additional-information-general-v3
  (nextStepEvent)="onNextStep()"
  *ngIf="isFlowKrdya">
</app-sales-additional-information-general-v3>

<app-sales-additional-information-general-v2
  (nextStepEvent)="onNextStep()"
  *ngIf="!isFlowKrdya">
</app-sales-additional-information-general-v2>
